﻿<template>
  <fieldset class="option-group accommodation">
    <div x-ref="radiogroup">
      <div v-for="room in order_Rooms_by_available(get_Room_List())" :class="{ checked: is_Selected(room) }">
        <!--available rooms-->
        <div v-if="get_Room_Available(room)">
          <!--the whole bordered option selects the room, the label has no for so a click only selects once-->
          <div class="item cursor-pointer" @click="select_room_type(room)">
            <div class="option-input">
              <input :id="get_ID(room)" type="radio" :checked="is_Selected(room)" :name="get_ID(room)" />
            </div>
            <div class="option-content">
              <label>
                <span class="room">
                  {{ room.name }}
                </span>
                <span :hidden="get_Room_Available(room)"> - Phone for Room Combination </span>
                <span class="price">
                  {{ get_Price(room) }}
                </span>
              </label>
              <label class="-mt-6 italic">{{get_room_description(room.name)}}</label>
            </div>
          </div>
        </div>

        <!--shows room but greyed out rooms-->
        <div v-else>
          <div class="item bg-grey-light rounded-t-lg" >
            <div class="option-input">
              <input :disabled="true" :id="get_ID(room)" type="radio" :checked="false" :name="get_ID(room)" @click="select_room_type(room)" />
            </div>
            <div class="option-content">
              <label :for="get_ID(room)">
                <span class="room">
                  {{ room.name }} (Unavailable)
                </span>
                <span :hidden="get_Room_Available(room)"> - Phone for this room Combination </span>
                <!-- <span class="price">
                  {{ get_Price(room) }} 
                </span> -->
              </label>
              <label class="-mt-6 italic">{{get_room_description(room.name)}}</label>
            </div>
            <div class="option-content"></div>
          </div>
          <div >
          </div>   
        </div>       
      </div>
    </div>
  </fieldset>
</template>

<script lang="ts" src="./sales_group_room_type.ts"></script>
